import { render, staticRenderFns } from "./outputFile.vue?vue&type=template&id=12b4523a&scoped=true"
import script from "./outputFile.vue?vue&type=script&lang=js"
export * from "./outputFile.vue?vue&type=script&lang=js"
import style0 from "./outputFile.vue?vue&type=style&index=0&id=12b4523a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b4523a",
  null
  
)

export default component.exports